import { format, isSameYear } from "date-fns";
import { DateRange } from "./types";

export const formatDateRange = (dateRange: DateRange) => {
  const today = new Date();
  if (isSameYear(dateRange.startDate, today)) {
    // Nov 14 - Dec 14
    return (
      format(dateRange.startDate, "MMM d") +
      " - " +
      format(dateRange.endDate, "MMM d")
    );
  } else {
    // Nov 14, 2023 - Dec 14, 2023
    return (
      format(dateRange.startDate, "MMM d, yyyy") +
      " - " +
      format(dateRange.endDate, "MMM d, yyyy")
    );
  }
};
